import React from 'react';

import { Launch } from '@carbon/icons-react';
import { Link } from 'react-router-dom';

import TextButton from 'components/Buttons/TextButton/TextButton';

import { DOCS_LINKS, DocsLinkKey } from 'app/containers/App/Router/routePaths';

import { useIsInternalDocsUrl } from 'app/hooks/useIsInternalDocsUrl';

import { config } from 'utils/config';

export interface DocsLinkProps {
  linkKey: DocsLinkKey;
  label: string;
  variant?: 'button' | 'text';
  icon?: JSX.Element | null;
}

const DocsLink = ({ linkKey, label, variant = 'button', icon = <Launch /> }: DocsLinkProps): JSX.Element => {
  const isInternalDocsUrl = useIsInternalDocsUrl();
  const relativeUrl = isInternalDocsUrl ? DOCS_LINKS[linkKey].internal : DOCS_LINKS[linkKey].external;

  return (
    <Link
      to={{ pathname: `${config.DOCS_SITE_URL}${relativeUrl}` }}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="documentation-link"
    >
      {variant === 'button' ? (
        <TextButton type="button" icon={icon} minimal intent="primary" text={label} testId="open-documentation-icon" />
      ) : (
        label
      )}
    </Link>
  );
};

export default DocsLink;
